/*
//-------------------------------------------------------
//   Copyright (c) 2024 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     DataFormOwnerTypes
//   Details:    DataFormOwnerTypes constant
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// WI3713 24/01/24 JC       Added
//-------------------------------------------------------
*/
export const dataFormOwnerTypes = {
	none: 0,
	document: 1
};
